import React from 'react';
import '../../Styles/Student/TestimonialCarousel.css';

interface Testimonial {
  id: number;
  name: string;
  review: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Sarah M.',
    review: 'StudyBuddy transformed my studies! The AI explanations helped me understand complex concepts I struggled with for months. Got an A+ on my final!',
  },
  {
    id: 2,
    name: 'Alex K.',
    review: 'The analysis feature is incredible. StudyBuddy helped me debug complex problems and explained concepts in ways my textbook never could.',
  },
  {
    id: 3,
    name: 'Maya L.',
    review: 'Creating presentations became so much easier with StudyBuddy\'s research assistance. My analysis improved dramatically.',
  },
  {
    id: 4,
    name: 'David Chen',
    review: 'The quiz generation from my notes saved me hours of study prep. Passed with flying colors!',
  },
  {
    id: 5,
    name: 'Emma Rodriguez',
    review: 'StudyBuddy\'s document analysis helped me synthesize research papers for my thesis. The insights were spot-on every time.',
  },
  {
    id: 6,
    name: 'Jordan Williams',
    review: 'Complex problems became manageable with StudyBuddy\'s step-by-step explanations. My GPA went from 3.2 to 3.8!',
  }
];

const TestimonialCarousel: React.FC = () => {
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <div className="testimonial-carousel">
      <div className="testimonial-track">
        {duplicatedTestimonials.map((testimonial, index) => (
          <div key={`${testimonial.id}-${index}`} className="testimonial-card">
            <div className="testimonial-content">
              <p>"{testimonial.review}"</p>
              <strong>— {testimonial.name}</strong>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialCarousel;